import {Injectable} from "@angular/core";
import {DeepLinkRemote} from "@app/core/shared/domain/deep-link.remote";
import {Observable} from "rxjs";
import {ProductDetails} from "@app/core/product/domain/dtos/product-details";

/**
 * Use case for generating a deep link for a product.
 * This use case creates a short link for a product that can be shared on social media platforms.
 */
@Injectable({
    providedIn: 'root'
})
export class CreateProductDeepLinkUseCase {
    constructor(
        private deepLinkRemote: DeepLinkRemote
    ) { }

    /**
     * It creates a short link for a product, which can be used to share the product on social media
     * @param {ProductDetails} product - ProductDetails - The product details object that contains the product code, name,
     * description, and image.
     * @param {string} [title] - The title of the link. By default it is the product name.
     * @returns The short link is being returned.
     */
    execute(product: ProductDetails, title?: string): Observable<string> {
        return this.deepLinkRemote.createProductDeepLink(product, title);
    }
}